// A spelling in tiles mode, shared by the web and native views: one slot per
// letter, tiles filling the first empty slot.

/** Each slot's tile id, or null while it is empty. */
export type SpellSlots = readonly (string | null)[];

export const startSpell = (letters: number): (string | null)[] =>
	Array.from({ length: letters }, () => null);

/** The tile into the first empty slot; null when every slot is full. */
export function placeLetter(slots: SpellSlots, id: string): (string | null)[] | null {
	const at = slots.indexOf(null);
	if (at < 0) return null;
	return slots.map((x, i) => (i === at ? id : x));
}

/** Empties a filled slot; null for an empty or absent one. */
export function clearLetter(slots: SpellSlots, i: number): (string | null)[] | null {
	if (slots[i] === null || slots[i] === undefined) return null;
	return slots.map((x, j) => (j === i ? null : x));
}

/**
 * The answer the shell grades: null while any slot is empty, so a half-built
 * word can never be submitted and counted as a mistake.
 */
export const spellAnswer = (slots: SpellSlots): string[] | null =>
	slots.every((x): x is string => x !== null) ? [...slots] : null;
